/* =================== BLOCOS HOME =================== */
jQuery(document).ready(function($) {
  $(".blocos-lista").slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 760,
        settings: "unslick"
      }
    ]
  });
});
